export interface PageSize { width: number; height: number }

/** Fit the complete page, including landscape/rotated pages, inside the available box. */
export function fitPageScale(page: PageSize, viewport: PageSize, inset = 0): number {
  if (![page.width, page.height, viewport.width, viewport.height].every((n) => Number.isFinite(n) && n > 0)) return 0;
  return Math.max(0, Math.min(
    (viewport.width - inset * 2) / page.width,
    (viewport.height - inset * 2) / page.height,
  ));
}
